export default "__VITE_ASSET__BDgT8EV9__"